// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"036c3a99b0f97f3ca22e","691":"041ff73f7351282e9592","731":"f2beca4aff45dd44df0c","843":"4ae3a0e76f0853d83ab2"}[chunkId] + ".js";
};